class SliderCompareProducts {
	constructor() {
		this.selectors = {
			document: document,
			slickCompareSlider: '.slickCompareSlider',
			sliderGroupFeatures: '.sliderGroupFeatures',
		};
		this.init();
		this.timeout_1 = null;
		this.timeout_2 = null;
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {

		// Slider for Compare Page
		this.nodes.slickCompareSlider.slick({
			dots: false,
			infinite: true,
			accessibility: false,
			speed: 200,
			arrows: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: false,
			prevArrow: $('#compare_slick_prev'),
			nextArrow: $('#compare_slick_next'),
			swipe: false,
			responsive: [{
				breakpoint: 1199,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			}, {
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
			]
		});
		$('#compare_slick_prev').on('click', function(){
			$('.sliderGroupFeatures').slick('slickPrev');
		});
		$('#compare_slick_next').on('click', function(){
			$('.sliderGroupFeatures').slick('slickNext');
		});

		this.nodes.sliderGroupFeatures.slick({
			dots: false,
			infinite: true,
			accessibility: false,
			speed: 200,
			arrows: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: false,
			asNavFor: '.slickCompareSlider',
			swipe: false,
			responsive: [{
				breakpoint: 1199,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			}, {
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
			]
		});

	}
}
new SliderCompareProducts();